import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}, null, -1)
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_11 = {
  key: 2,
  class: "badge badge-light-info"
}
const _hoisted_12 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_13 = {
  key: 4,
  class: "badge badge-light-primary"
}
const _hoisted_14 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisteredTradesAdvancedSearch = _resolveComponent("RegisteredTradesAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'registered-trades'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RegisteredTradesAdvancedSearch, {
                onFilterSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onFilterSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.can('read', 'registered-trades'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('registered-trades-listing')))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('returnToRegisteredTradesListing')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.id), 1)
            ]),
            "cell-transactionDate": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.transactionDate), 1)
            ]),
            "cell-descriptionAr": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.descriptionAr), 1)
            ]),
            "cell-block": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.block), 1)
            ]),
            "cell-areaName": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.areaName), 1)
            ]),
            "cell-propertyTypeName": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.propertyTypeName), 1)
            ]),
            "cell-price": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.price
              ? new Intl.NumberFormat('en-US').format(registeredTrade.price)
              : ''), 1)
            ]),
            "cell-size": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.size), 1)
            ]),
            "cell-pricePerM2": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.pricePerM2), 1)
            ]),
            "cell-notes": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(registeredTrade.notesAr), 1)
            ]),
            "cell-status": _withCtx(({ row: registeredTrade }) => [
              (registeredTrade.status == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " صفقة صحيحة "))
                : (registeredTrade.status == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " صفقة تم تصحيحها "))
                  : (registeredTrade.status == 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " مشكوك فى صحتها "))
                    : (registeredTrade.status == 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " صفقة خاطئة "))
                      : (registeredTrade.status == 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " بلوك "))
                        : _createCommentVNode("", true)
            ]),
            "cell-statusNotes": _withCtx(({ row: registeredTrade }) => [
              _createTextVNode(_toDisplayString(_ctx.getStatusNoteText(registeredTrade.statusNotesId)), 1)
            ]),
            "cell-is_active": _withCtx(({ row: registeredTrade }) => [
              (registeredTrade.is_active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: registeredTrade }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editRegisteredTrades(registeredTrade.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_16),
              (_ctx.can('remove', 'registered-trades'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusRegisteredTrades(registeredTrade)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}